import chooseService4 from "../images/chooseService4.png";
import chooseService3 from "../images/chooseService3.png";
import chooseService2 from "../images/chooseService2.png";
import chooseService1 from "../images/chooseService1.png";

export const chooseServiceImage = {
    chooseService1,
    chooseService2,
    chooseService3,
    chooseService4
}
